import { useRequiredContext } from "@redotech/react-util/context";
import MessageTextCircle02Icon from "@redotech/redo-icons/message-text-circle-02.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { matchPath, useLocation } from "react-router-dom";

export const TextConciergeItems = memo(function TextConciergeItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const location = useLocation();

  const anyChildSelected = !!matchPath(
    `${routes.textConciergeHref}/*`,
    location.pathname,
  );

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.textConciergeHref }}
      anyChildSelected={anyChildSelected}
      FilledIcon={MessageTextCircle02Icon}
      friendlyName="Text Concierge"
      id="text-concierge"
      UnfilledIcon={MessageTextCircle02Icon}
    />
  );
});
